import { Modal, Space, Card, Row, Col, Flex, Button } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as ExcelIcon } from "../../../../assets/icon/excelIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg";

function DownloadItem({ name, fileType, loading = false, onDownload, downloadLabel }) {
    return (
        <Card
            style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
            styles={{ body: { padding: "16px" } }}
        >
            <Row style={{ width: "100%" }}>
                <Col span={16}>
                    <Flex gap={16} align="center">
                        <ExcelIcon />
                        <Flex vertical>
                            <span style={{ fontWeight: "bold", color: "#42526D" }}>{name}</span>
                            <span style={{ color: "#42526D" }}>{fileType}</span>
                        </Flex>
                    </Flex>
                </Col>
                <Col span={8} style={{ alignContent: "center", justifyItems: "flex-end" }}>
                    <Button
                        type="default"
                        style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                        onClick={onDownload}
                        loading={loading}
                        disabled={loading}
                        icon={!loading ? <DownloadIcon style={{ fontSize: 16 }} /> : null}
                    >
                        <span style={{ color: "#59687F", fontWeight: "bold" }}>{downloadLabel}</span>
                    </Button>
                </Col>
            </Row>
        </Card>
    );
}

function WorkingTimeModal({
    isModalOpen,
    setIsModalOpen,
    isDownloading = false,
    isDownloadingTA = false,
    exportWorkingTimeGroupReport = () => { },
    exportTimeAttendanceReport = () => { },
    name = ""
}) {
    const { t } = useTranslation();

    return (
        <Modal
            title={<span color="#42526D">{t("report.label.download_file")}</span>}
            destroyOnClose
            open={isModalOpen}
            footer={null}
            closable={false}
            maskClosable={false}
        >
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <span style={{ fontSize: "14px", color: "#667085" }}>
                    {t("report.modal.description")}
                </span>

                <DownloadItem
                    name={name}
                    fileType={t("common.excel_file")}
                    loading={isDownloading}
                    onDownload={() => exportWorkingTimeGroupReport()}
                    downloadLabel={t("common.download")}
                />

                <DownloadItem
                    name={t("time_attendance_report.header", { defaultValue: "Time Attendance Report" })}
                    fileType={t("common.excel_file")}
                    loading={isDownloadingTA}
                    onDownload={() => exportTimeAttendanceReport()}
                    downloadLabel={t("common.download")}
                />

                <Row justify="end">
                    <Button style={{ borderRadius: "8px", height: "40px" }} type="default" onClick={() => setIsModalOpen(false)}>
                        <span style={{ fontWeight: "bold", color: "#344054" }}>{t("common.cancel").toUpperCase()}</span>
                    </Button>
                </Row>
            </Space>
        </Modal>
    );
}

export default WorkingTimeModal;